import React from "react";
import "../styles/components/pagination.css";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  if (totalPages <= 1) return null;

  // Tính toán các trang cần hiển thị
  const getPageNumbers = () => {
    const pages: (number | string)[] = [];

    // Luôn thêm trang 1
    pages.push(1);

    if (totalPages <= 7) {
      // Nếu tổng số trang <= 7, hiển thị tất cả
      for (let i = 2; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    // Trường hợp 1: Trang hiện tại ở đầu (1, 2, 3)
    if (currentPage <= 3) {
      // Hiển thị: 1 2 3 4 ... (trang cuối)
      for (let i = 2; i <= 4; i++) {
        pages.push(i);
      }
      if (totalPages > 5) {
        pages.push("...");
      }
      pages.push(totalPages);
      return pages;
    }

    // Trường hợp 2: Trang hiện tại ở cuối
    if (currentPage >= totalPages - 2) {
      // Hiển thị: 1 ... (trang cuối - 3) (trang cuối - 2) (trang cuối - 1) (trang cuối)
      pages.push("...");
      for (let i = totalPages - 3; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    // Trường hợp 3: Trang hiện tại ở giữa
    // Hiển thị: 1 ... (currentPage - 1) currentPage (currentPage + 1) ... (trang cuối)
    pages.push("...");
    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
      pages.push(i);
    }
    pages.push("...");
    pages.push(totalPages);

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="pagination">
      <button
        className="pagination-btn"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Trước
      </button>

      <div className="pagination-numbers">
        {pageNumbers.map((page, index) => {
          if (page === "...") {
            return (
              <span key={`ellipsis-${index}`} className="pagination-ellipsis">
                ...
              </span>
            );
          }

          const pageNum = page as number;
          return (
            <button
              key={pageNum}
              className={`pagination-number ${
                currentPage === pageNum ? "active" : ""
              }`}
              onClick={() => onPageChange(pageNum)}
            >
              {pageNum}
            </button>
          );
        })}
      </div>

      <button
        className="pagination-btn"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Sau
      </button>
    </div>
  );
};

export default Pagination;

